import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Button, Heading, Modal, ModalControlModalProps, Text } from '@frontend/design-system';

interface Props extends ModalControlModalProps {
  hasAutoReminder?: boolean;
  onPrimaryAction: () => void;
  onCancel: () => void;
}

export const BookingSuccessModal = ({ hasAutoReminder = false, onPrimaryAction, onCancel, ...modalProps }: Props) => {
  const { t } = useTranslation('schedule-onboarding');

  return (
    <Modal {...modalProps} maxWidth={400}>
      <Modal.Header onClose={modalProps.onClose}>
        <div css={{ textAlign: 'center', paddingLeft: theme.spacing(6) }}>
          <span css={{ fontSize: theme.fontSize(80) }}>🎉</span>
        </div>
      </Modal.Header>
      <Modal.Body>
        <Heading level={2} css={{ lineHeight: '28px', textAlign: 'center' }}>
          {t('Congratulations! Your first appointment is booked')}
        </Heading>
        <Text weight='regular' css={{ textAlign: 'center' }}>
          {hasAutoReminder
            ? t(
                'Want to prevent no-shows? Set up automatic reminders to cut last minute cancellations and no-show rates by 10%'
              )
            : t(
                'Want to prevent no-shows? Upgrade your bundle to to cut last minute cancellations and no-show rates by 10%'
              )}
        </Text>
      </Modal.Body>
      <Modal.Footer>
        <div css={{ display: 'flex', justifyContent: 'center', gap: theme.spacing(2) }}>
          <Button variant='secondary' onClick={onCancel}>
            {t('Skip')}
          </Button>
          <Button onClick={onPrimaryAction}>{hasAutoReminder ? t('Set up auto reminder') : t('Upgrade Now')}</Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
